import { v4 as uuidv4 } from "uuid";
export class AppsListingModel {
    constructor() {
        this.appsId = uuidv4();
        this.productId = uuidv4();
    }
}
export default class Products extends AppsListingModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
